import { render, staticRenderFns } from "./UnidadMedidaSelectComponent.vue?vue&type=template&id=a505470a&"
import script from "./UnidadMedidaSelectComponent.vue?vue&type=script&lang=js&"
export * from "./UnidadMedidaSelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports